import { Component, OnInit, ViewChild, TemplateRef, Input, EventEmitter, Output } from '@angular/core';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
import {
  PagingParameters, SortParameters, SortParametersDirection,
  SmartViewSQLStatementResultsWithPagingRequest, FieldAgentClient,
  SmartViewColumn
} from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import {
  EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult,
  EpGridEvent, IEpGridSelectionOptions, IEpComponentEventArg, IEpGridColumn, EpEventService, EpButtonStyle
} from '@epicor/kinetic';
declare var $: any;
import { IEpBtCardControlModel, BistrackConfig, LocalStorageSaveTypes, CustomEvents, SearchPageNames } from 'ep-bt-controls';
import { EpbtFaDynamicViewModel } from '../../models/epbt-fa-dynamic-view-model';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFaSmartviewsDetailsComponent } from '../epbt-fa-smartviews-details/epbt-fa-smartviews-details.component';
import { Observable } from 'rxjs';
import { EpbtFaSmartTilesService } from '../../services/epbt-fa-smart-tiles.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-smartviews-grid',
  templateUrl: './epbt-fa-smartviews-grid.component.html',
  styleUrls: ['./epbt-fa-smartviews-grid.component.scss']
})
export class EpbtFaSmartviewsGridComponent implements OnInit {

  EpButtonStyle = EpButtonStyle;

  selectedFolderData: any;
  paging: PagingParameters;
  public pageSize = 50;
  smartViewResults: SmartViewSQLStatementResultsWithPagingRequest;
  webTrackUser: any;
  smartViewList: any;
  svList: any;
  public gridModel: IEpGridModel;
  public cards: Array<IEpBtCardControlModel>;

  public smartviews: EpbtFaDynamicViewModel[] = [];
  columnData: IEpGridColumn[] = [];
  noText: any;
  SmartViewDataTable: any;
  smartView: any;
  smartViewColumns: SmartViewColumn[] = [];
  smartViewSelectedColumns: SmartViewColumn[] = [];
  columnNamesList: string[] = [];
  LimitNumberOfItemsPerCard = 5;
  smartviewId: number;
  // ShowChildGrid: boolean = false;


  totalPages = 1;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;
  smartviewsCollection: any = [];
  @Input() set isShow(value: any) {
    this.updateGrid();
  }
  @Output() loadingChange = new EventEmitter<boolean>();



  @ViewChild('numberTemplate', {static: false}) numberTemplate: TemplateRef<any>;
  @ViewChild(EpbtFaSmartviewsDetailsComponent, {static: false}) epbtFaSmartviewsDetailsComponent: EpbtFaSmartviewsDetailsComponent;

  constructor(private router: Router, public SmartviewsService: EpbtFaSmartviewsService,
    private fieldAgentService: EpbtFieldAgentService, private client: FieldAgentClient, public epEvent: EpEventService, public faSmartTilesService: EpbtFaSmartTilesService) {
    this.epEvent.onEvents([CustomEvents.Smartviews]).subscribe(event => {
      this.smartviewId = event.data;
      this.faSmartTilesService.navigateTo = 'Grid';
      this.smartViewListdata(event.data);
      this.faSmartTilesService.setSmartViewHeader(event.data); // For set header
      this.SmartviewsService.selectedDashboardId = event.data; // save dashboardId for details header
    });
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });

    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      // this.smartViewListdata();

      // this.getGridData();
      if (this.SmartviewsService.smartviewId) {
        // this.faSmartTilesService.navigateTo = "Graph";
        this.smartviewId = this.SmartviewsService.smartviewId;
        this.smartViewListdata(this.SmartviewsService.smartviewId);
      }
    });
    if (this.SmartviewsService.fromPage == SearchPageNames.SmartviewDetails || this.SmartviewsService.fromPage == undefined) {
      this.SmartviewsService.isShowChildGrid = false;
    } else {
      this.SmartviewsService.isShowChildGrid = true;
    }
  }

  // grid model start
  getGridModel(data: any[]): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      // data: data,
      columns: this.columnData,
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToDetailsView(eventArg.event.dataItem);
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, data, false, this.smartviewId);
        return observerResult;
      }
    };
    return model;
  }
  // grid model end

  // navigation start

  navigateToDetailsView(args) {
    this.SmartviewsService.selectedGridData = args;
    this.SmartviewsService.selectSmartViewColumnsData = args.fullObj;
    this.faSmartTilesService.smartTilesTitle = ''; //
    this.SmartviewsService.isShowChildGrid = true; ///
    this.SmartviewsService.setSmartViewDetailsHeader(this.SmartviewsService.selectedDashboardId, args);
    this.epbtFaSmartviewsDetailsComponent.ngOnInit(); ///
    // this.router.navigate(['/home/smartviews/details']);
  }

  // grid height calculation start
  getHeight(): number {


    const bottomPadding = 20;
    if (!this.faSmartTilesService.isShow) {

      return $(window).outerHeight() - ($('.epbt-smart-tiles').offset().top + bottomPadding - 5);
    }
    const width = parseInt($('body').width());
    if (width > 250 && width < 1023) {
      // mobile and ipad
      if (this.faSmartTilesService.gridInitialHeight) {
        return $(window).outerHeight() - (this.faSmartTilesService.gridInitialHeight + bottomPadding + 22);
      }
      this.faSmartTilesService.gridInitialHeight = $('.smart-tile-body').offset().top;
      return $(window).outerHeight() - ($('.smart-tile-body').offset().top + bottomPadding + 22);


    }
    if (this.faSmartTilesService.gridInitialHeight) {
      return $(window).outerHeight() - (this.faSmartTilesService.gridInitialHeight + bottomPadding + 10);
    } else {
      this.faSmartTilesService.gridInitialHeight = $('.smart-tile-body').offset().top;
      return $(window).outerHeight() - ($('.smart-tile-body').offset().top + bottomPadding + 10);
    }

  }

  // grid height calculation end


  // pgination logic start

  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, smartviewListData, isMobile: boolean, smartviewId: number): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.smartviewsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {

        this.SmartviewsService.isShowChildGrid = false;
        this.smartviewId = smartviewId;
        this.smartViewResults = new SmartViewSQLStatementResultsWithPagingRequest();
        this.smartViewResults.smartViewId = smartviewId;
        this.smartViewResults.user = this.webTrackUser;
        // Paging
        this.paging = new PagingParameters();
        this.paging.index = state.skip + 1;
        this.paging.count = this.pageSize;
        this.smartViewResults.pagingParameters = this.paging;
        // Current year
        this.smartViewResults.currentYear = new Date().getFullYear();
        // Current month
        this.smartViewResults.currentMonth = new Date().getMonth();
        // Fiscal year
        this.smartViewResults.fiscalYear = new Date().getFullYear();
        // Fiscal month
        this.smartViewResults.fiscalMonth = new Date().getMonth();



        this.client.getSmartViewResultsWithPagingAndParseEx(this.fieldAgentService.bisTrackSetting.webTrackInstanceID, this.smartViewResults).subscribe(res => {
          // smartviewListData = res.tables[0];

          if (res && res.tables && res.tables.length > 0) {

            smartviewListData = [];
            res.tables[0].forEach(item => {
              let row: any;
              row = {
                key1: this.smartViewSelectedColumns.length > 0 ? this.smartViewSelectedColumns[0].caption : '0',
                value1: this.smartViewSelectedColumns.length > 0 ? item[this.columnNamesList[0]] : '',
                key2: this.smartViewSelectedColumns.length > 1 ? this.smartViewSelectedColumns[1].caption : '1',
                value2: this.smartViewSelectedColumns.length > 1 ? item[this.columnNamesList[1]] : '',
                key3: this.smartViewSelectedColumns.length > 2 ? this.smartViewSelectedColumns[2].caption : '2',
                value3: this.smartViewSelectedColumns.length > 2 ? item[this.columnNamesList[2]] : '',
                key4: this.smartViewSelectedColumns.length > 3 ? this.smartViewSelectedColumns[3].caption : '3',
                value4: this.smartViewSelectedColumns.length > 3 ? item[this.columnNamesList[3]] : '',
                fullObj: item
              };
              smartviewListData.push(row);
            });

            this.totalPages = res.recordsCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (smartviewListData.length < state.take) {
              this.lastRecords = smartviewListData;
            } else {
              this.smartviewsCollection = [...this.smartviewsCollection, ...smartviewListData];
            }
            if (!isMobile) {
              this.mobileData = this.smartviewsCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.smartviewsCollection.length;
            const result: IEPGridDataResult = {
              data: smartviewListData,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }


        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  updateGrid() {
    const calHeight = this.getHeight();
    if (this.gridModel) {
      this.gridModel.height = calHeight;
      this.faSmartTilesService.gridHeight = calHeight;
    }

  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true, this.smartviewId).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  // pagination logic end

  // Smart VIews List Api Start
  smartViewListdata(smartviewId: number) {
    this.SmartviewsService.isShowChildGrid = false;
    this.smartviewId = smartviewId; ///
    // this.selectedFolderData = this.SmartviewsService.selectedFolderItem;//
    this.smartViewResults = new SmartViewSQLStatementResultsWithPagingRequest();

    this.smartViewResults.smartViewId = smartviewId;
    this.smartViewResults.user = this.webTrackUser;
    // Paging
    this.paging = new PagingParameters();
    this.paging.index = 1;
    this.paging.count = 1;
    this.smartViewResults.pagingParameters = this.paging;
    // Current year
    this.smartViewResults.currentYear = new Date().getFullYear();
    // Current month
    this.smartViewResults.currentMonth = new Date().getMonth();
    // Fiscal year
    this.smartViewResults.fiscalYear = new Date().getFullYear();
    // Fiscal month
    this.smartViewResults.fiscalMonth = new Date().getMonth();

    // API Start
    this.client.getSmartViewResultsWithPagingAndParseEx(this.fieldAgentService.bisTrackSetting.webTrackInstanceID, this.smartViewResults).subscribe(res => {

      this.smartViewList = res.tables[0];
      // this.SmartviewsService.selectSmartViewColumnsData = res.tables[0];
      this.smartViewColumns = res.smartViewColumns;
      this.SmartviewsService.columns = res.smartViewColumns;
      this.gridHeaderDataPrepare();
      this.updateGrid();
      this.clearGridDetails();
    });

  }


  gridHeaderDataPrepare() {
    const table = this.smartViewList[0];
    this.columnNamesList = [].slice();
    const columnCaptionsList: string[] = [];
    const list: any[] = [];
    const keys = this.keys(table);

    keys.forEach(data => {
      const col = this.smartViewColumns.find(x => x.listColumnName.toUpperCase() == (this.smartviewId.toString() + '_' + data.toUpperCase()));
      if (col != null && !col.hidden) {
        if (this.columnNamesList.length <= this.LimitNumberOfItemsPerCard) {
          this.columnNamesList.push(data);
          columnCaptionsList.push(col.caption);
        } else {
          return;
        }
      }
    });
    if (this.columnNamesList.length > 0) {
      this.smartViewList.forEach(item => {
        let row: any;
        row = {
          key1: this.columnNamesList[0],
          value1: item[this.columnNamesList[0]],
          key2: this.columnNamesList.length > 1 ? this.columnNamesList[1] : '1',
          value2: this.columnNamesList.length > 1 ? item[this.columnNamesList[1]] : '',
          key3: this.columnNamesList.length > 2 ? this.columnNamesList[2] : '2',
          value3: this.columnNamesList.length > 2 ? item[this.columnNamesList[2]] : '',
          key4: this.columnNamesList.length > 3 ? this.columnNamesList[3] : '3',
          value4: this.columnNamesList.length > 3 ? item[this.columnNamesList[3]] : ''
        };
        list.push(row);
      });
      this.createColumns(list);
    }
  }


  keys(obj) {
    return Object.keys(obj);
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }
  createColumns(list: any[]) {
    // if (list && list.length > 0) {
    //   var currentItem = list[0];
    //   this.columnData = [
    //     { field: 'value1', title: currentItem.key1, width: 100, hidden: false },
    //     { field: 'value2', title: currentItem.key2, width: 80, hidden: false },
    //     { field: 'value3', title: currentItem.key3, width: 100, hidden: false },
    //     { field: 'value4', title: currentItem.key4, width: 80, hidden: false }
    //   ];
    // }
    this.smartViewSelectedColumns = this.smartViewColumns.slice(0, 4);
    if (this.smartViewSelectedColumns && this.smartViewSelectedColumns.length > 0) {
      this.columnData = [];
      let i = 0;
      this.smartViewSelectedColumns.forEach(item => {
        if (i < 4) {
          const index = i + 1;
          this.columnData.push({ field: 'value' + index, title: item.caption, width: 100, hidden: false });
        }
        i = i + 1;
      });

      // this.columnData = [
      //   { field: 'value1', title: this.smartViewColumns[0].caption, width: 100, hidden: false },
      //   { field: 'value2', title: this.smartViewColumns[1].caption, width: 80, hidden: false },
      //   { field: 'value3', title: this.smartViewColumns[2].caption, width: 100, hidden: false },
      //   { field: 'value4', title: this.smartViewColumns[3].caption, width: 80, hidden: false }
      // ];
    }

    this.gridModel = this.getGridModel([]);
  }

  clearGridDetails() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.smartviewsCollection = [].slice();
    this.smartViewColumns = [].slice();
    setTimeout(() => {
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }
}

